import React from "react";
import axios from 'axios';
import Products from "../Components/Products";
import './ProductList.css';
import { useParams } from "react-router-dom";
//import Slider from "react-slick";
import Loader from "../Components/Loader";
import Breadcrumb from '../Components/Breadcrumb';
class Searchresult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],title :[],check:false,notFound:false,
            loading:false,loading:true
        }
        
    }; 
    componentDidMount(){
        this.setState({check:true}) 
        const  {id}  = this.props.params ;
        this.setState({title:id})
            axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/method/ecom.api.item_search?item=' +id + '&pin=' + localStorage.getItem('pin')), {
                headers : {'Authorization' : process.env.REACT_APP_TOKEN, 
            'content-type': 'application/json'}
            })
                    .then(response=>{
                        this.setState({list:response.data.message})
                        this.setState({check:false}) 
                        this.setState({loading:false})
                       //console.log(response.data)  
                    })
                    .catch(response=>{
                        //console.log(response+' api/method/ecom.api.item_list?item_group_route=')
                    })
        

    } 
    render() {
         return this.state.loading ? <Loader/>:<div> 
         <Breadcrumb head="shop" group={this.props.group} url="/shop"/>
         <div className="shop-category-area mt-30px">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                {/*  <!-- Shop Top Area Start --> */}
                                <div className="shop-top-bar d-flex">
                                    {/*  <!-- Left Side start --> */}
                                    <div className="shop-tab nav d-flex">
                                        <a className="active" href="#shop-1" data-bs-toggle="tab">
                                            <i className="fa fa-th"></i>
                                        </a>
                                        {/* <a href="#shop-2" data-bs-toggle="tab">
                                            <i className="fa fa-list"></i>
                                        </a> */}
                                       
                                       <p>There Are {this.state.list.length} Products.</p>
                                    </div>
                                    {/* <!-- Left Side End -->
                                    <!-- Right Side Start --> */}
                                    <div className="select-shoing-wrap d-flex justify-center">
                                       
                                        <div className="shop-select">
                                           <h3 className="group-title" >{this.props.group}</h3>
                                        </div>
                                    </div>
                                    {/* <div className="select-shoing-wrap d-flex">
                                        <div className="shot-product">
                                            <p>Sort By:</p>
                                        </div>
                                        <div className="shop-select">
                                            <select>
                                                <option value="">Sort by newness</option>
                                                <option value="">A to Z</option>
                                                <option value=""> Z to A</option>
                                                <option value="">In stock</option>
                                            </select>
                                        </div>
                                    </div> */}
                                    {/*  <!-- Right Side End --> */}
                                </div>
                                {/* <!-- Shop Top Area End -->*/}
                                {/* <!-- Shop Bottom Area Start --> */}
                                <div className="shop-bottom-area mt-35">
                                {/*   <!-- Shop Tab Content Start --> */}
                                    <div className="tab-content jump">
                                        {/*  <!-- Tab One Start --> */}
                                        <div id="shop-1" className="tab-pane active">
                                            <div className="row m-0">
                                            {this.state.list.map((itm,k)=>{
                            return(
                                            <Products key={k} data={itm}/>)
                                        })} 
                                               
                                            </div>
                                        </div>
                                    {/*  <!-- Tab One End --> */}
                                        
                                    </div>
                                    {/* <!-- Shop Tab Content End -->
                                    <!--  Pagination Area Start --> */}
                                    
                                    {/*  <!--  Pagination Area End --> */}
                                </div>
                                {/* <!-- Shop Bottom Area End --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                /* <!-- Shop Category Area End --> */
              
            }
        }
        export default (props) => (
            <Searchresult
                {...props}
                params={useParams()}
        />)
    